import Livesearch from "adeliom-livesearch-js/dist/livesearch";
import JsChoices from "./_choices";
import Swiper from "swiper";
import Breakpoints from "../utils/_breakpoints";

const Filters = {};

const jsFiltersButtonSelector = 'js-open-filters';
const jsFiltersSelector = 'js-filters';
const jsFiltersCloseSelector = 'js-filters-close';
const jsFilterSubmitSelector = 'js-livesearch-submit';
const jsFiltersCounterSelector = 'js-filters-counter';
const jsFiltersResetSelector = 'js-livesearch-reset';
const jsFiltersUpdateSelector = 'js-update-filters';
const jsScrollTopFiltersSelector = 'js-top-filters';

const jsLettersMirrorFormSelector = 'js-letters-mirror-form';
const jsLettersMirrorFormPrevious = 'js-letters-mirror-previous';
const jsLettersMirrorFormNext = 'js-letters-mirror-next';

const currentClass = 'current';

const jsFiltersForm = 'js-livesearch-form';

const letterSliderConfig = {
    direction: 'horizontal',
    loop: false,
    slidesPerView: 2,
    spaceBetween: 4,
    breakpoints: {
        370: {
            slidesPerView: 4,
        },
        720: {
            slidesPerView: 6,
        },
        1280: {
            slidesPerView: 12,
        },
    }
};


const activeClass = 'active';

let filtersOpened = false;
let filtersElt = null;
let filtersScrollTop = null;
let filtersForm = null;
let livesearch = null;
let filtersCount = null;
let filtersCounter = null;
let lettersMirrorForm = null;
let letterFields = null;
let letterLabels = null;
let letterLabelsInSlider = null;
let letterSlider = null;
let filtersUpdateTimeout = null;
let mainContainer = null;

const filtersUpdateDebounce = 500; // ms

const livesearchSettings = {
    "pathAjax": "",
    "actionAjax": "",
    "filtersSelector": "[js-livesearch-form]",
    "resultsSelector": "[js-livesearch-results]",
    "loadingSelector": "[js-livesearch-loading]",
    "paginationSelector": "[js-livesearch-pagination]",
    "resetSelector": "[" + jsFiltersResetSelector + "]",
    "noResultSelector": "[js-livesearch-noresult]",
    "pageNumberSelector": "[js-livesearch-page]",
    "submitSelector": "[" + jsFilterSubmitSelector + "]",
    "perPage": 9,
    "minimumTimeLoading": filtersUpdateDebounce,
    "paramsInUrl": true,
    "animationScrollTo": "smooth",
};

const initLivesearch = () => {
    if (null === livesearch) {
        let form = getFiltersForm();

        if (getFiltersForm().hasAttribute('js-action')) {
            livesearchSettings.pathAjax = getFiltersForm().getAttribute('js-action');
        }

        if (getFiltersForm().hasAttribute('js-ajax')) {
            livesearchSettings.actionAjax = getFiltersForm().getAttribute('js-ajax');
        }

        if (getFiltersForm().hasAttribute('js-per-page')) {
            livesearchSettings.perPage = getFiltersForm().getAttribute('js-per-page');
        }

        const livesearch = new Livesearch(livesearchSettings);
        livesearch.init();

        livesearch.on('pageChange', (response) => {
            scrollToFiltersTop();
        });

        livesearch.on('beforeChange', (response) => {
            scrollToFiltersTop();
        });
    }

    return livesearch;
};

const setFilterButtonEvent = (button) => {
    button.addEventListener('click', (e) => {
        e.preventDefault();
        toggleFilters();
    });
};

const toggleFilters = () => {
    if (filtersOpened) {
        closeFilters();
    } else {
        openFilters();
    }
};

const getFiltersScrollTop = () => {
    if (null === filtersScrollTop) {
        filtersScrollTop = document.querySelector('[' + jsScrollTopFiltersSelector + ']');
    }

    return filtersScrollTop;
};

const getMainContainer = () => {
    if (null === mainContainer) {
        mainContainer = document.querySelector('.main > .content');
    }

    return mainContainer;
};

const getFiltersElt = () => {
    if (null === filtersElt) {
        filtersElt = document.querySelector('[' + jsFiltersSelector + ']');
    }

    return filtersElt;
};

const getFiltersForm = () => {
    if (null === filtersForm) {
        filtersForm = document.querySelector('[' + jsFiltersForm + ']');
    }

    return filtersForm;
};

const getFiltersCounter = () => {
    if (null === filtersCounter) {
        filtersCounter = document.querySelector('[' + jsFiltersCounterSelector + ']');
    }

    return filtersCounter;
};

const openFilters = () => {
    if (null !== getFiltersElt()) {
        getFiltersElt().classList.add(activeClass);
        filtersOpened = !filtersOpened;
    }
};

const closeFilters = () => {
    if (null !== getFiltersElt()) {
        getFiltersElt().classList.remove(activeClass);
        filtersOpened = !filtersOpened;
    }
};

const isElementInFilterPane = (element) => {
    return null !== element.closest('[' + jsFiltersSelector + ']') || element.hasAttribute(jsFiltersSelector);
};

const isElementFiltersButton = (element) => {
    return null !== element.closest('[' + jsFiltersButtonSelector + ']') || element.hasAttribute(jsFiltersButtonSelector);
};

const getNumberFilledFields = () => {
    const formData = new FormData(getFiltersForm());
    filtersCount = 0;

    formData.forEach(value => {
        if (value !== '') {
            filtersCount++;
        }
    });
};

const resetFiltersCounter = () => {
    filtersCount = null;
    if (null !== getFiltersCounter()) {
        getFiltersCounter().parentNode.parentNode.classList.remove('basic-header__buttons--counter');
        getFiltersCounter().style.display = 'none';
        getFiltersCounter().textContent = '';
    }
};

const updateFiltersCounter = () => {
    const displayed = filtersCount === 0 ? null : filtersCount;
    if (null !== displayed) {
        getFiltersCounter().parentNode.parentNode.classList.add('basic-header__buttons--counter');
        getFiltersCounter().style.display = '';
        getFiltersCounter().textContent = displayed;
    } else {
        resetFiltersCounter();
    }
};

const getCurrentLetter = () => {
    const formData = new FormData(getFiltersForm());

    if (formData.get('letter')) {
        return formData.get('letter');
    }

    return 'all';
};

const getLetterFields = () => {
    if (null === letterFields) {
        letterFields = getFiltersForm().querySelectorAll('input[name=letter]');
    }

    return letterFields;
};

const getLetterLabels = () => {
    if (null === letterLabels) {
        letterLabels = getLettersMirrorForm().querySelectorAll('.letter-btn');
    }

    return letterLabels;
};

const getLetterLabelsInSlider = () => {
    if (null === letterLabelsInSlider) {
        letterLabelsInSlider = getLettersMirrorForm().querySelector('.swiper-container').querySelectorAll('.letter-btn');
    }

    return letterLabelsInSlider;
};

const getLetterLabelFromLetter = (letter) => {
    if (letter === 'all') {
        letter = getLetterLabels()[0].textContent;
    }

    let goodLabel = null;

    getLetterLabels().forEach(label => {
        if (label.textContent === letter) {
            goodLabel = label;
        }
    });

    return goodLabel;
};

const getPreviousLabelFromLabel = (label) => {
    let previousIndex = null;

    for (let i = 0; i < getLetterLabels().length; i++) {
        if (getLetterLabels()[i] === label) {
            if (i > 0) {
                previousIndex = i - 1;
            }
            break;
        }
    }

    return null !== previousIndex ? getLetterLabels()[previousIndex] : null;
};

const getNextLabelFromLabel = (label) => {
    let nextIndex = null;

    for (let i = 0; i < getLetterLabels().length; i++) {
        if (getLetterLabels()[i] === label) {
            if (i < (getLetterLabels().length - 1)) {
                nextIndex = i + 1;
            }
            break;
        }
    }

    return null !== nextIndex && null !== getLetterLabels()[nextIndex] ? getLetterLabels()[nextIndex] : null;
};

const getLetterLabelIndex = (label) => {
    let index = null;

    for (let i = 0; i < getLetterLabelsInSlider().length; i++) {
        if (getLetterLabelsInSlider()[i] === label) {
            index = i;
            break;
        }
    }

    return index;
};

const isElementVisibleInContainer = (element, container) => {
    const containerBoundaries = container.getBoundingClientRect();
    const elementBoundaries = element.getBoundingClientRect();

    if (elementBoundaries.top >= containerBoundaries.top && elementBoundaries.bottom <= containerBoundaries.bottom) {
        if (elementBoundaries.left >= containerBoundaries.left && elementBoundaries.right <= containerBoundaries.right) {
            return true;
        }
    }

    return false;
};

const slideToLabel = (label) => {
    if (!isElementVisibleInContainer(label, label.parentNode.parentNode)) {
        let index = getLetterLabelIndex(label);
        if (null !== index) {
            letterSlider.slideTo(index);
        }
    }
};

const getFieldAssociatedToLabel = (label) => {
    let field = null;

    for (let i = 0; i < getLetterFields().length; i++) {
        if (getLetterFields()[i].getAttribute('id') === label.getAttribute('for')) {
            field = getLetterFields()[i];
            break;
        }
    }

    return field;
};

const handleLettersPrevious = (e) => {
    letterSlider.slidePrev();
    return;

    let currentLabel = getLetterLabelFromLetter(getCurrentLetter());
    let previousLabel = getPreviousLabelFromLabel(currentLabel);

    if (null !== previousLabel) {
        slideToLabel(previousLabel);

        let associatedField = getFieldAssociatedToLabel(previousLabel);

        if (null !== associatedField) {
            associatedField.click();
        }

        const event = new CustomEvent('sliderClick');
        previousLabel.dispatchEvent(event);
    }
};

const handleLettersNext = (e) => {
    letterSlider.slideNext();
    return;

    let currentLabel = getLetterLabelFromLetter(getCurrentLetter());
    let nextLabel = getNextLabelFromLabel(currentLabel);

    if (null !== nextLabel) {
        slideToLabel(nextLabel);

        /*let associatedField = getFieldAssociatedToLabel(nextLabel);

        if (null !== associatedField) {
            associatedField.click();
        }

        const event = new CustomEvent('sliderClick');
        nextLabel.dispatchEvent(event);*/
    }
};

const getLettersMirrorForm = () => {
    if (null === lettersMirrorForm) {
        lettersMirrorForm = document.querySelector('[' + jsLettersMirrorFormSelector + ']');
    }

    return lettersMirrorForm;
};

const handleLettersArrowsStates = () => {
    const previous = getLettersMirrorForm().querySelector('[' + jsLettersMirrorFormPrevious + ']');
    const next = getLettersMirrorForm().querySelector('[' + jsLettersMirrorFormNext + ']');

    let currentLabel = getLetterLabelFromLetter(getCurrentLetter());

    if (null === getPreviousLabelFromLabel(currentLabel)) {
        previous.classList.add('disabled');
    } else {
        previous.classList.remove('disabled');
    }

    if (null === getNextLabelFromLabel(currentLabel)) {
        next.classList.add('disabled');
    } else {
        next.classList.remove('disabled');
    }
};

const handleLettersState = () => {
    getLetterLabels().forEach(label => {
        label.classList.remove(currentClass);
    });

    getLetterLabelFromLetter(getCurrentLetter()).classList.add(currentClass);
};

const initLettersMirrorForm = () => {

    if (null !== getLettersMirrorForm()) {
        const previous = getLettersMirrorForm().querySelector('[' + jsLettersMirrorFormPrevious + ']');
        const next = getLettersMirrorForm().querySelector('[' + jsLettersMirrorFormNext + ']');

        previous.addEventListener('click', (e) => {
            e.preventDefault();
            handleLettersPrevious(e);
        });

        next.addEventListener('click', (e) => {
            e.preventDefault();
            handleLettersNext(e);
        });
    }
};

const initLettersMirrorSlider = (config) => {
    letterSlider = new Swiper(getLettersMirrorForm().querySelector('.swiper-container'), config);

    setTimeout(() => {
        let currentLabel = getLetterLabelFromLetter(getCurrentLetter());
        slideToLabel(currentLabel);
    }, 100);
};

const resetSlider = () => {
    slideToLabel(getLetterLabelsInSlider()[0]);
    getLetterLabelsInSlider().forEach(label => {
        label.classList.remove(currentClass);
    });
    getLetterLabelFromLetter('all').classList.add(currentClass);
};

const scrollToFiltersTop = () => {
    if (null !== getFiltersScrollTop()) {
        let scrollTopPositions = getFiltersScrollTop().offsetTop;

        switch (true) {
            case window.innerWidth > Breakpoints.sm && window.innerWidth <= Breakpoints.md:
                scrollTopPositions += 40;
                break;
            case window.innerWidth > Breakpoints.md && window.innerWidth <= Breakpoints.lg:
                scrollTopPositions += 96;
                break;
            case window.innerWidth > Breakpoints.lg:
                scrollTopPositions += 112;
                break;
            default:
                scrollTopPositions += 24;
                break;
        }

        getMainContainer().scrollTo({
            top: scrollTopPositions,
            behavior: 'smooth',
        });
    }
};

Filters.init = () => {
    document.addEventListener('DOMContentLoaded', () => {
        const filtersButtons = document.querySelectorAll('[' + jsFiltersButtonSelector + ']');
        const filtersCloseButtons = document.querySelectorAll('[' + jsFiltersCloseSelector + ']');
        const filtersSubmitButtons = document.querySelectorAll('[' + jsFilterSubmitSelector + ']');
        const filtersResetButtons = document.querySelectorAll('[' + jsFiltersResetSelector + ']');
        const filtersUpdateButtons = document.querySelectorAll('[' + jsFiltersUpdateSelector + ']');

        if (null !== getFiltersForm() && null !== getFiltersElt()) {
            filtersButtons.forEach(button => setFilterButtonEvent(button));
            filtersCloseButtons.forEach(closeBtn => {
                closeBtn.addEventListener('click', () => {
                    closeFilters();
                });
            });

            window.addEventListener('click', (e) => {
                if (filtersOpened) {
                    if (!isElementInFilterPane(e.target) && !isElementFiltersButton(e.target)) {
                        closeFilters();
                    }
                }
            });

            getFiltersForm().addEventListener('change', () => {
                getNumberFilledFields();
            });

            filtersSubmitButtons.forEach(button => {
                button.addEventListener('click', () => {
                    updateFiltersCounter();
                    closeFilters();
                })
            });

            filtersResetButtons.forEach(button => {
                button.addEventListener('click', () => {
                    setTimeout(() => {
                        resetFiltersCounter();
                        closeFilters();
                        JsChoices.resetAll();

                        if (null !== getLettersMirrorForm()) {
                            resetSlider();
                        }
                    }, 10);
                })
            });

            initLivesearch();

            if (null !== filtersUpdateButtons) {
                if (null !== getLettersMirrorForm()) {
                    getFiltersForm().addEventListener('change', () => {
                        handleLettersArrowsStates();
                        handleLettersState();
                    });
                }

                filtersUpdateButtons.forEach(button => {
                    button.addEventListener('click', (e) => {
                        setTimeout(() => {
                            filtersSubmitButtons[0].click();
                        }, 10);
                    });

                    button.addEventListener('sliderClick', () => {
                        if (null !== filtersUpdateTimeout) {
                            clearTimeout(filtersUpdateTimeout);
                        }

                        filtersUpdateTimeout = setTimeout(() => {
                            filtersSubmitButtons[0].click();
                        }, filtersUpdateDebounce);
                    });
                });

                if (null !== getLettersMirrorForm()) {
                    handleLettersArrowsStates();
                    handleLettersState();
                    initLettersMirrorForm();
                    initLettersMirrorSlider(letterSliderConfig);
                }
            }

            getNumberFilledFields();
            updateFiltersCounter();
        }
    });
};

Filters.isOpened = () => {
    return filtersOpened;
};

export default Filters;
